var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$disabled)?_c('button',{attrs:{"type":"button"},on:{"click":_vm.$submit}},[_vm._t("default",[_vm._v(_vm._s(_vm.$label))])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }